import React from "react";
import {
  useForm,
  UseFormReturn,
  FieldValues,
  DefaultValues,
} from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Button } from "../ui/button";
import "./styles/form-wrapper.css";

export interface FormWrapperProps<T extends FieldValues = FieldValues> {
  schema: z.ZodType<T>;
  defaultValues?: DefaultValues<T>;
  onSubmit: (data: T) => Promise<void> | void;
  children: (form: UseFormReturn<T>) => React.ReactNode;
  submitText?: string;
  isLoading?: boolean;
  className?: string;
}

export function FormWrapper<T extends FieldValues = FieldValues>({
  schema,
  defaultValues,
  onSubmit,
  children,
  submitText = "Сохранить",
  isLoading = false,
  className = "",
}: FormWrapperProps<T>) {
  const formOptions: any = {
    resolver: zodResolver(schema as any),
    ...(defaultValues !== undefined && { defaultValues }),
  };

  const form = useForm<T>(formOptions);

  const handleSubmit = async (data: T) => {
    try {
      await onSubmit(data);
    } catch (error) {
      // Handle form submission error
      throw error;
    }
  };

  return (
    <form
      onSubmit={form.handleSubmit(handleSubmit) as any}
      className={`form-wrapper__form form-space-y-6 ${className}`}
    >
      {children(form as any)}

      <div className="form-wrapper__actions">
        <Button
          type="submit"
          disabled={isLoading || !form.formState.isValid}
          className="form-wrapper__submit-button"
        >
          {isLoading ? "Сохранение..." : submitText}
        </Button>
      </div>
    </form>
  );
}

export default FormWrapper;
